import styled, { css, keyframes } from 'styled-components';

import { sharedStyles } from '../styled';

const pulseRing = (ringColor: string) => keyframes`
  0% {
    box-shadow: 0 0 0 0 ${ringColor};
    transform: translateZ(0) scale(1);
  }
  60% {
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    transform: translateZ(0) scale(1.01);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    transform: translateZ(0) scale(1);
  }
`;

export const Button = styled.button<{
  $highlighted?: boolean;
  $iconOnly?: boolean;
}>`
  color: white;
  background: #2374f2;
  box-shadow: 0 1px 3px 1px #00000036;
  border-radius: 5px;
  ${sharedStyles}

  ${({ $highlighted }) =>
    $highlighted
      ? css`
          --ring: ${({ theme }) => theme.color.brightTurquoise || '#007bff'};
          animation: ${pulseRing('var(--ring)')} 900ms ease-out 0ms infinite;
          outline: 4px solid var(--ring);
          outline-offset: ${({ $iconOnly }) => ($iconOnly ? 8 : 2)}px;
        `
      : null}

  svg {
    width: 36px;
    height: 36px;
    margin-right: 10px;
  }

  ${({ $iconOnly }) =>
    $iconOnly &&
    css`
      width: 54px;
      height: 54px;
      border-radius: 50%;
      padding: 0;
      svg {
        margin: 0;
      }
    `}
`;
